import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';
import { ListItem, QuickFilterKey } from '.';

type Props = {
  list: ListItem[];
  onClick: (filter: QuickFilterKey) => void;
};

export const QuickFilterCards = ({ list, onClick }: Props) => (
  <div css={styles.root}>
    {list.map((item) => (
      <NakedButton key={item.label} css={styles.item} trackingId={item.trackingId} onClick={() => onClick(item.key)}>
        <Icon name={item.iconName} size={16} color='subdued' css={{ flexShrink: 0 }} />
        <Text size='medium' weight='bold'>
          {item.count}
        </Text>
        <Text size='medium' color='subdued'>
          {item.label}
        </Text>
      </NakedButton>
    ))}
  </div>
);

const styles = {
  root: css`
    display: flex;
    align-items: center;
    gap: ${theme.spacing(1)};
  `,
  item: css`
    display: flex;
    align-items: center;
    white-space: nowrap;
    gap: ${theme.spacing(0.5)};
    padding: ${theme.spacing(0.5, 1.5)};
    border: 1px solid ${theme.colors.neutral30};
    border-radius: ${theme.borderRadius.small};
  `,
};
